import * as React from "react";
import { BiUser } from "react-icons/bi";
import { TbSortAscending } from "react-icons/tb";
import { Spinner } from "reactstrap";
import { rankingLabels, movementIcon, formatRankingData } from "../utils/formatRankingData";

const RankingTable = (props) => {
  const { filter, data, user, label, isLoading } = props;
  
  const formattedData = React.useMemo(() => 
    formatRankingData(data, user?.data.id),
    [data, user]
  );

  return (
    <div
      className="d-flex"
      style={{
        flexDirection: "column",
        WebkitBoxShadow: "0px 5px 5px 4px rgba(0,0,0,0.25)",
        MozBoxShadow: "0px 5px 5px 4px rgba(0,0,0,0.25)",
        boxShadow: "0px 5px 5px 4px rgba(0,0,0,0.25)",
        borderRadius: "15px",
        width: "503px",
        margin: "2rem",
        position: "relative",
        minHeight: "450px"
      }}
    >
      <div
        style={{
          minWidth: "100%",
          backgroundColor: "#1D1F3F",
          borderRadius: "15px",
          padding: "0.65rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <h3 style={{ color: "white", fontWeight: 600, textAlign: "center" }}>
          {label}
        </h3>
      </div>

      <div style={{ padding: "0.5rem", marginTop: "1rem" }}>
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
            <Spinner color="primary" />
          </div>
        ) : (
          <React.Fragment>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <BiUser size={25} color="#1D1F3F" />
                <span>Participantes</span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <TbSortAscending size={25} color="#1D1F3F" />
                <span>{rankingLabels[filter]}</span>
              </div>
            </div>

            <hr
              style={{
                maxWidth: "80%",
                borderWidth: "1.5px",
                backgroundColor: "#1D1F3F",
              }}
            />

            <div
              style={{ maxHeight: "20rem", minHeight: "20rem", overflowY: "auto" }}
            >
              {formattedData.map((x, index) => (
                <div
                  key={x.id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    border: "1.5px solid #1D1F3F",
                    borderRadius: "15px",
                    margin: "0.5rem 15%",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: index < 3 ? "#0075AC" : "#1D1F3F",
                        color: "white",
                        fontWeight: 600,
                        padding: "0.5rem 1rem",
                        borderTopLeftRadius: "13px",
                        borderBottomLeftRadius: "13px",
                        alignItems: "center",
                        width: "2.5rem",
                        textAlign: "center",
                      }}
                    >
                      {x.displayPosition}
                    </div>

                    <span
                      style={{
                        color: "#1D1F3F",
                        ...(x.isCurrentUser && { fontWeight: "bold" }),
                      }}
                    >
                      {x.name}
                    </span>
                  </div>

                  <div
                    style={{
                      alignSelf: "center",
                      marginRight: "0.5rem",
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    {x.hasMovement && (
                      <span>
                        {x.movementSymbol} {x.movementAmount}
                      </span>
                    )}
                    {x.hasMovement && movementIcon[x.movementDirection]}

                    <span
                      style={{
                        width: "3rem",
                        display: "inline-block",
                        color: "#1D1F3F",
                      }}
                    >
                      {x.value}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <span
              style={{
                margin: "1rem",
                textAlign: "center",
                display: "inline-block",
              }}
            >
              Para poder calcular tu posición diaria, los datos mostrados se
              comparan con los del día anterior
            </span>

            {data.length > 0 && (
              <span
                style={{
                  margin: "0 1rem",
                  textAlign: "center",
                  display: "inline-block",
                }}
              >
                <strong>Total de participantes: {data.length}.</strong> El ranking
                se calcula con la información recopilada de tus dispositivos de
                monitoreo.
              </span>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default RankingTable;
